import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import { _delete, get, patch, putWithHeadersResponse } from "../../../server/actions";
import NotificationSystem from 'react-notification-system';
import ReactTable from 'react-table';
import { BeatLoader } from 'react-spinners';
import { _addNotification, _addNotificationError } from "../../../server/util";
import active from "../../../assets/img/active.png";
import warn from "../../../assets/img/warning.png";
import deleted from "../../../assets/img/invalid.png";
import { access_token, ENV } from '../../../server/constants';


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

class CatererList extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            modalIsOpen: false,
            catererList: [],
            catererData: [],
            search: '',
            catererOpenRecId: 0
        }
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.editCaterer = this.editCaterer.bind(this);

        this.getAllCatererList = this.getAllCatererList.bind(this);
    }
    componentWillMount = () => {
        this.getAllCatererList()
    }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    openModal() {
        //alert(JSON.stringify(col,null,2))
        //mealSchoolId = col._links.self.href.split('/').pop();
        this.setState({ modalIsOpen: true });

    }
    getAllCatererList = () => {
        this.setState({ loading: true })
        get('/caterers?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.getSchoolCount(data)
        })
            .catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get SchoolList response', error)
                }
            )
    }
    getSchoolCount = (data) => {
        get('/getCountByCategory?category=School&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data1 => {

            this.setState({
                loading: false,
                catererList: data._embedded.caterers.map(item => {
                    const cid = item._links.self.href.split('/').pop();
                    let primaryUser = item.catererUsers.filter(cate => cate.isPrimaryUser === true)[0] || {};
                    const findObj = data1.response.find(x => x.catererId == cid) || {}

                    item.schoolCount = findObj.schoolCount || 0;
                    item.schoolNames = findObj.schoolNames || '';
                    return { ...item, ...primaryUser };
                }) || []
            }, () => {
                this.filterCatererList()
            });
        })
            .catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get SchoolList response', error)
                }
            )
    }
    editCaterer = (row, action) => {
        let id = 0;
        if (row) {
            id = row._links.self.href.split('/').pop();
            setTimeout(() => {
                this.context.router.history.push('/superAdmin/catererRecord/' + id)
            }, 1000);
        }
    }
    afterOpenModal() {
        // references are now sync'd and can be accessed.
        // this.subtitle.style.color = '#f00';
    }
    closeModal() {
        this.setState({ modalIsOpen: false });
    }
    deleteCaterer = () => {
        alert("delete");
    }
    sendAdminLinks = (username) => {
        this.setState({ loading: true });
        //alert(col._links.self.href.split('/').pop())       
        get('/catererAccActivation?' + 'username=' + username + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response;
        }).then(data => {
            _addNotification('Successfully sent emails.', this);
            this.setState({ loading: false });
            console.log('Access Links Sent', data);
        }).catch(
            (error) => {
                this.setState({ loading: false }, () => {
                    _addNotificationError('Send links failed. Please try again later.', this);
                });
            });
    };
    catererUser = (catererId) => {
        this.setState({ catererOpenRecId: catererId });
        const url = `/registerAsCatererUser/${catererId}?access_token=`;
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
        putWithHeadersResponse(url, undefined, headers)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((data) => {
                const url = ENV == "Development" ? `${window.location.protocol}//devcaterer${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}` : ENV == "Production" ? `${window.location.protocol}//caterer${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}` : `${window.location.protocol}//qacaterer${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}`
                window.open(
                    `${url}`,
                    '_blank' // <- This is what makes it open in a new window.
                );
                this.setState({ catererOpenRecId: 0 });

            }).catch(error => {
                this.setState({ loading: false, catererOpenRecId: 0 });
                _addNotificationError('Could not updated caterer data.', this);
            });
    }
    getColumns = () => {
        const columns = [
            {
                Header: 'CATERER NAME',
                width: 300,
                Cell: ({ row }) => {
                    const sid = row._original._links.self.href.split('/').pop();
                    return <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <a href="javascript:void(0);" style={{ cursor: 'pointer' }} className="text-info"
                            onClick={() => { this.editCaterer(row._original, "EDIT") }}>
                            {row._original.name}</a>
                        <a href="javascript:void(0);" title="Admin URL" onClick={() => {
                            const cid = isNaN(Number(sid)) ? 0 : Number(sid);
                            if (this.state.catererOpenRecId == 0) {
                                this.catererUser(cid);
                            }
                        }}><i className="fa fa-external-link" style={{ fontSize: '18px' }} aria-hidden="true"></i></a>
                    </div>
                }
            },

            {
                Header: 'No.Of Schools',
                accessor: 'schoolCount',
                width: 150
            },
            {
                Header: 'Schools',
                Cell: ({ row }) => {
                    const item = row._original;
                    return <ul>{(item.schoolNames || '').split(',').map(school => {
                        return <li>{school}</li>
                    })}</ul>
                },
                width: 300
            },
            {
                Header: 'CATERER ADMIN',
                Cell: ({ row }) => {
                    const item = row._original;
                    return <span>{(item.lastName || '') + ' ' + (item.firstName || '')}</span>
                },
                width: 300
            },
            {
                Header: "EMAIL",
                Cell: ({ row }) => {
                    const item = row._original;
                    return (<Fragment>
                        <span>
                            <img alt="action"
                                src={item.isActive ? active : warn}
                                style={{
                                    paddingRight: '5px',
                                    cursor: 'pointer',
                                    width: '22px'
                                }} />
                            {item.username}
                            {
                                item.isVerified === true ? null :
                                    <a onClick={() => this.sendAdminLinks(item.username)}><i
                                        className="fa fa-paper-plane-o" style={{ 'font-size': '14px', 'color': '#84bed6', 'padding': '5px', 'cursor': 'pointer' }} /></a>
                            }
                        </span>
                    </Fragment>)
                }

            },
            {
                Header: 'ACTION',
                width: 100,
                Cell: ({ row }) => {
                    const sid = row._original._links.self.href.split('/').pop();
                    return <Fragment>
                        <a href="javascript:void(0);" style={{ cursor: 'pointer' }} className="edit-btn"
                            onClick={() => { this.editCaterer(row._original, "EDIT") }}>
                            <i className="fa fa-pencil tbl-rounded-icon bg-color-1 fa-icon" /></a>

                        <a href="javascript:void(0);" className="delete-btn" style={{ display: 'none', cursor: 'pointer' }} onClick={() => this.openModal()}>
                            <i className="fa fa-trash-o tbl-rounded-icon bg-color-3 fa-icon" /></a>
                    </Fragment>
                }
            }];
        return columns
    }
    filterCatererList = () => {
        let data = [];
        const { search, catererList } = this.state;
        if (search.length > 0) {
            catererList.forEach(obj => {
                if (obj.name != null && (obj.name.toLowerCase()).startsWith(search.toLowerCase())) {
                    data.push(obj);
                } else if (obj.firstName != null && (obj.firstName.toLowerCase()).startsWith(search.toLowerCase())) {
                    data.push(obj);
                } else if (obj.lastName != null && (obj.lastName.toLowerCase()).startsWith(search.toLowerCase())) {
                    data.push(obj);
                } else if (obj.username != null && (obj.username.toLowerCase()).startsWith(search.toLowerCase())) {
                    data.push(obj);
                }
                else if ((obj.schoolNames || '').length > 0) {
                    let x = false;
                    (obj.schoolNames || '').split(',').forEach(school => {
                        if (school.toLowerCase().startsWith(search.toLowerCase())) {
                            x = true;
                        }

                    });
                    x === true ? data.push(obj) : '';
                }
            });
        } else {
            data = catererList;
        }
        this.setState({ catererData: data })
    }
    render() {
        return (<Fragment>
            <NotificationSystem ref="notificationSystem" />
            <section className=" full-width clearfix">
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container-full">
                    <div className="sectionTitle">
                        <h2>
                            <span>Caterers</span>
                        </h2>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12 form-group">
                            <input type="text" id="search" className="search form-control" value={this.state.search}
                                name="search" placeholder="Search.." onChange={(e) => {
                                    this.setState({ search: e.target.value }, () => {
                                        this.filterCatererList()
                                    });
                                }} autocomplete='off'
                            />
                        </div>
                        <div className="col-md-6 col-sm-12 col-xs-12 button-group-section form-group">
                            <Link className="btn btn-success button-sm add-btn-sm"
                                id="addCaterer" onClick={() => { this.editCaterer(null, "NEW") }}
                                to="/superAdmin/catererRecord"><i className="fa fa-plus" /> Add Caterer</Link>
                        </div>
                    </div>

                    <div className="row">
                        <div className='col-md-12'>
                            <div className="clearfix"></div>
                            <div className="panel panel-primary">
                                <div className="panel-body">
                                    <ReactTable
                                        data={this.state.catererData}
                                        columns={this.getColumns()}
                                        defaultPageSize={10}
                                        className="-striped -highlight"
                                        noDataText='No data found'
                                        sortable={true}
                                        defaultSorting={[{
                                            id: 'session',
                                            desc: false
                                        }]}
                                        minRows={1}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <div className="container">
                    <div className="sectionTitle">
                        <h2>
                            <span></span>
                        </h2>
                    </div>

                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12 form-group">
                            <input type="text" id="search" className="search form-control"
                                   name="search" placeholder="Search.." onKeyUp={(e) => {}}/>
                        </div>
                        <div className="col-md-6 col-sm-12 col-xs-12 button-group-section form-group">
                            <Link className="btn btn-success button-sm add-btn-sm"
                                  id="addCaterer" onClick={()=>{this.editCaterer(null, "NEW")}}
                                  to="/superAdmin/catererRecord"><i className="fa fa-plus"/> Add Caterer</Link>
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="table-responsive">                   
                            <table className="table table-hover">
                                    <thead>
                                    <tr className="bg-success base-reverse">
                                        <th>CATERER NAME</th>
                                        <th>No.Of Schools</th>
                                        <th>Schools</th>
                                        <th>CATERER ADMIN</th>
                                        <th>EMAIL</th>
                                        <th className="text-center">ACTION</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        this.state.catererList.map((item,k)=>{                                            
                                            return(<tr key={k}>
                                                <td> 
                                                <a href='javascript:void(0)' className="text-info" 
                                                onClick={()=>{this.editCaterer(item, "EDIT")}}>
                                                {item.name}</a></td>
                                                <td>{item.schoolCount}</td>
                                                <td><ul>{(item.schoolNames||'').split(',').map(school=>{
                                                    return <li>{school}</li>
                                                })}</ul></td>
                                                <td>{item.lastName+' '+item.firstName}</td>                                                
                                                <td><div>
                                                            <span>                                                           
                                                                <img alt="action"
                                                                     src={item.isActive?active:warn}
                                                                     style={{
                                                                         paddingRight: '5px',
                                                                         cursor: 'pointer',
                                                                         width: '22px'
                                                                     }}/>
                                                                {item.username}
                                                                { 
                                                                    item.isVerified === true ?null: 
                                                                    <a onClick={() => this.sendAdminLinks(item.username)}><i
                                                            className="fa fa-paper-plane-o" style={{ 'font-size':'14px',  'color':'#84bed6','padding': '5px','cursor':'pointer'}}  /></a>
                                                    } 
                                                            </span>
                                                        </div>
                                                  </td>

                                                <td className="actions text-center" style={{whiteSpace: 'nowrap'}}>
                                                    <div>
                                                        <a className="edit-btn"
                                                        onClick={()=>{this.editCaterer(item, "EDIT")}}>
                                                        <i className="fa fa-pencil tbl-rounded-icon bg-color-1 fa-icon"/></a>
                                                        
                                                        <a className="delete-btn" style={{display:'none'}} onClick={() => this.openModal()}>
                                                        <i className="fa fa-trash-o tbl-rounded-icon bg-color-3 fa-icon"/></a>
                                                    </div>
                                                </td>
                                            </tr>)
                                        })
                                    }      
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </Fragment>);
    }
}
CatererList.contextTypes = {
    router: PropTypes.object.isRequired
}

export default CatererList;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/caterer/catererList.jsx